angular.module 'zc.master.zcliteProjects'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.zcliteProjects',
    url: '/zclite_projects'
    views:
      'content@':
        templateUrl: '/templates/master.zclite_projects/list.html'
        controller: 'MasterZcliteProjectsListCtrl'




// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_projects/routes.coffee